import React from 'react';
import { organizationDisplayModel } from '@/features/enterprise/helpers';
import { format } from 'date-fns';
import DocumentHeading from '../../components/DocumentHeading';

interface Props {
  title: string;
  photo?: string;
  encounter: fhir4.Encounter;
}

const DocumentPanelHeader: React.FC<Props> = ({ title, photo, encounter }) => {
  const headerInfo = React.useMemo(() => {
    const info = [];
    const { location, organization } = organizationDisplayModel(encounter);
    const healthcareProvider = [location, organization]
      .filter(Boolean)
      .join(' | ');

    if (healthcareProvider) {
      info.push({ name: 'Entidade de saúde', value: healthcareProvider });
    }

    info.push({
      name: 'Data de emissão',
      value: format(new Date(), 'dd/MM/yyyy'),
    });

    return info;
  }, [encounter]);

  return <DocumentHeading title={title} photo={photo} infos={headerInfo} />;
};

export default DocumentPanelHeader;
